<template>
  <div>
    <p>
      {{ label }}
    </p>
    <select
      class="custom-select"
      style="
        max-width: 9rem;
        width: 144px;
        height: 2.375rem;
        font-size: 0.875rem;
        border: 2px solid rgb(255, 255, 255);
        box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px;
        color: rgb(95, 95, 95);
      "
      v-model="selected"
      name="commonSelectInput"
    >
      <option :disabled="disableLock" value="">
        {{ disableText }}
      </option>
      <option
        v-for="(option, index) in options"
        :value="option.value"
        :disabled="option.value == ''"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    disableText: {
      type: String,
    },
    disableLock: {
      type: Boolean,
      default: true,
    },
    disableValue: {
      default: null,
    },
    options: {
      type: Array,
      default: [],
    },
  },
  emits: ["update:getValue"],
  setup(props, { emit }) {
    const selected = ref("");

    if (props.disableValue !== null) {
      selected.value = props.disableValue;
      emit("update:getValue", selected.value);
    } else {
      selected.value = "";
    }

    console.log("disableText >>" + props.disableText);

    watch(
      selected,
      (newValue) => {
        emit("update:getValue", newValue);
      },
      { deep: true }
    );

    watch(
      () => props.options,
      (newValue) => {
        if (props.disableValue !== null) {
          selected.value = props.disableValue;
        } else {
          let checkValue = false;
          newValue.forEach((data) => {
            if (data.value == selected.value) {
              checkValue = true;
            }
          });
          if (!checkValue) {
            selected.value = "";
          }
        }
      },
      { deep: true }
    );

    return {
      selected,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
}
.custom-select {
  display: inline-block;
  width: 100%;
  height: 2.375rem;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
}
</style>
